import React from 'react';
import DocumentCategoriesList from './DocumentCategoriesList';
import OverallStatsDisplay from './OverallStatsDisplay';
import styles from '../../../styles/DocumentManagement.module.css';
import { UserDocumentsProps } from '../../../types/DocumentManagement';

// Props interface now imported from types file

const UserDocuments: React.FC<UserDocumentsProps> = React.memo(({
  userDetails,
  selectedUser,
  overallStats,
  categoriesWithStats,
  categoriesMetadata,
  canManageUsers,
  documentLoading,
  documentError,
  AgentsList
}) => {
  // Dynamic subtitle based on user permissions
  const subtitle = canManageUsers 
    ? "Manage and track documents for individual users within your agency."
    : "Manage and track your personal documents and compliance requirements.";

  return (
    <>
      <div className={styles.documentManagementHeader}>
        <h1 className={styles.documentManagementTitle}>User Documents</h1>
        <p className={styles.documentManagementSubtitle}>{subtitle}</p>
      </div>

      {/* For testing: show agent selection only if user can manage agency users */}
      {canManageUsers && userDetails?.agency?.agencyId && (
        <div className={styles.documentManagementSection}>
          <h3>👥 Select Agent to Manage</h3>
          <AgentsList 
            agencyId={userDetails.agency.agencyId}
            displayMode="dropdown"
          />
          <OverallStatsDisplay 
            stats={overallStats}
            title="Overall Completion"
            showDetails={true}
          />
        </div>
      )}

      {selectedUser && (
        <div className={styles.documentManagementSection}>
          <DocumentCategoriesList 
            categoriesWithStats={categoriesWithStats}
            categoriesMetadata={categoriesMetadata}
            overallStats={overallStats}
            loading={documentLoading}
            error={documentError}
            isCompanyMode={false}
          />
        </div>
      )}
    </>
  );
});

// Add display name for debugging
UserDocuments.displayName = 'UserDocuments';

export default UserDocuments;
